import { load } from "js-yaml";
import remarkFrontmatter from "remark-frontmatter";
function frontmatter({
  onError
} = {}) {
  return {
    remark: (processor) => processor.use(remarkFrontmatter).use(() => (tree, file) => {
      const fisrtNode = tree.children[0];
      if ((fisrtNode == null ? void 0 : fisrtNode.type) !== "yaml")
        return;
      try {
        file.frontmatter = load(fisrtNode.value);
      } catch (err) {
        onError == null ? void 0 : onError(err);
      }
    })
  };
}
export {
  frontmatter as default
};
